(function() {
  if (window.themeProductGridQuantityReady) return;
  window.themeProductGridQuantityReady = true;

  var cartState = null;
  var cartRequest = null;
  var pendingQuantities = {};
  var updateTimers = {};
  var updateInFlight = {};
  var inputTimers = {};
  var cartUpdateInFlight = false;
  var cartUpdateRetryTimer = null;
  var updateDelay = 180;

  function getControls() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-grid-quantity-control]'));
  }

  function getVariantId(control) {
    return Number(control.dataset.variantId);
  }

  function getInput(control) {
    return control.querySelector('[data-grid-qty-input]');
  }

  function getQuantity(input) {
    var value = parseInt(input.value, 10);
    return Number.isFinite(value) && value > 0 ? value : 0;
  }

  function setInputQuantity(input, quantity) {
    input.value = quantity;
    input.setAttribute('value', String(quantity));
  }

  function hasOwn(object, key) {
    return Object.prototype.hasOwnProperty.call(object, key);
  }

  function setStatus(control, message) {
    var status = control.querySelector('[data-grid-qty-status]');
    if (status) status.textContent = message || '';
  }

  function formatMoney(cents, currency) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }

    var activeCurrency = currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

    return new Intl.NumberFormat(document.documentElement.lang || undefined, {
      style: 'currency',
      currency: activeCurrency
    }).format(cents / 100);
  }

  function updateOrderTotal(control, quantity) {
    var row = control.closest('[data-order-row]');
    var total = row ? row.querySelector('[data-order-total]') : null;
    if (!total) return;

    var priceCents = Number(total.dataset.priceCents || 0);
    total.textContent = formatMoney(priceCents * quantity, total.dataset.currency);
  }

  function isVariantUpdating(variantId) {
    return hasOwn(pendingQuantities, variantId) || Boolean(updateTimers[variantId]) || Boolean(updateInFlight[variantId]);
  }

  function setLoading(variantId, loading) {
    getControls().forEach(function(control) {
      if (getVariantId(control) !== variantId) return;
      control.classList.toggle('is-loading', loading);
      setStatus(control, loading ? 'Updating cart' : '');
    });
  }

  function setDisplayedQuantity(variantId, quantity) {
    getControls().forEach(function(control) {
      if (getVariantId(control) !== variantId) return;

      var input = getInput(control);
      var minus = control.querySelector('[data-grid-qty-decrease]');

      if (!input) return;
      setInputQuantity(input, quantity);
      updateOrderTotal(control, quantity);
      if (minus) minus.disabled = quantity === 0;
      control.classList.add('is-loading');
      setStatus(control, 'Updating cart');
    });
  }

  function requestJson(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: body ? JSON.stringify(body) : undefined
    }).then(function(response) {
      if (!response.ok) {
        var error = new Error('Cart request failed');
        error.status = response.status;
        throw error;
      }
      return response.json();
    });
  }

  function fetchCart(force) {
    if (!force && cartState) return Promise.resolve(cartState);
    if (!force && cartRequest) return cartRequest;

    cartRequest = requestJson('/cart.js').then(function(cart) {
      cartState = cart;
      cartRequest = null;
      return cart;
    }).catch(function(error) {
      cartRequest = null;
      throw error;
    });

    return cartRequest;
  }

  function updateHeaderCartCount(count) {
    document.querySelectorAll('.theme-header__cart, .hdr__cart, .hdr__mobile-cart').forEach(function(cartLink) {
      var countEl = cartLink.querySelector('.theme-header__cart-count, .hdr__cart-count');

      if (count > 0) {
        if (!countEl) {
          countEl = document.createElement('span');
          countEl.className = cartLink.classList.contains('theme-header__cart') ? 'theme-header__cart-count' : 'hdr__cart-count';

          var cartIcon = cartLink.querySelector('svg');
          if (cartIcon) {
            cartIcon.insertAdjacentElement('afterend', countEl);
          } else {
            cartLink.appendChild(countEl);
          }
        }

        countEl.textContent = count;
      } else if (countEl) {
        countEl.remove();
      }
    });
  }

  function buildQuantityMap(cart) {
    var quantities = {};

    (cart.items || []).forEach(function(item) {
      quantities[item.variant_id] = (quantities[item.variant_id] || 0) + item.quantity;
    });

    return quantities;
  }

  function syncControls(cart) {
    var quantities = buildQuantityMap(cart);

    getControls().forEach(function(control) {
      var variantId = getVariantId(control);
      var input = getInput(control);
      var minus = control.querySelector('[data-grid-qty-decrease]');
      var serverQuantity = quantities[variantId] || 0;
      var displayQuantity = hasOwn(pendingQuantities, variantId) ? pendingQuantities[variantId] : serverQuantity;
      var updating = isVariantUpdating(variantId);

      if (!input) return;
      setInputQuantity(input, displayQuantity);
      updateOrderTotal(control, displayQuantity);
      input.dataset.cartQuantity = String(serverQuantity);
      if (minus) minus.disabled = displayQuantity === 0;
      control.classList.toggle('is-loading', updating);
      setStatus(control, updating ? 'Updating cart' : displayQuantity + ' in cart');
    });

    updateHeaderCartCount(cart.item_count || 0);
  }

  function getPendingVariantIds() {
    return Object.keys(pendingQuantities).filter(function(variantId) {
      return hasOwn(pendingQuantities, variantId);
    });
  }

  function commitPendingQuantities(retryCount) {
    if (cartUpdateInFlight) return;

    var variantIds = getPendingVariantIds();
    var updates = {};
    var requestedQuantities = {};

    if (!variantIds.length) return;

    retryCount = retryCount || 0;
    cartUpdateInFlight = true;

    variantIds.forEach(function(variantId) {
      requestedQuantities[variantId] = pendingQuantities[variantId];
      updates[variantId] = pendingQuantities[variantId];
      updateInFlight[variantId] = true;
      setLoading(Number(variantId), true);
    });

    requestJson('/cart/update.js', { updates: updates })
      .then(function(cart) {
        cartState = cart;
        cartUpdateInFlight = false;

        variantIds.forEach(function(variantId) {
          updateInFlight[variantId] = false;

          if (pendingQuantities[variantId] === requestedQuantities[variantId]) {
            delete pendingQuantities[variantId];
          }
        });

        syncControls(cart);

        if (getPendingVariantIds().length) {
          commitPendingQuantities();
        } else if (window.themeShowToast) {
          window.themeShowToast('Cart updated');
        }
      })
      .catch(function(error) {
        cartUpdateInFlight = false;

        variantIds.forEach(function(variantId) {
          updateInFlight[variantId] = false;
        });

        if (error.status === 409 && retryCount < 3) {
          window.clearTimeout(cartUpdateRetryTimer);
          cartUpdateRetryTimer = window.setTimeout(function() {
            fetchCart(true)
              .then(syncControls)
              .catch(function() {})
              .then(function() {
                commitPendingQuantities(retryCount + 1);
              });
          }, 250 * (retryCount + 1));
          return;
        }

        variantIds.forEach(function(variantId) {
          if (pendingQuantities[variantId] === requestedQuantities[variantId]) {
            delete pendingQuantities[variantId];
          }
        });

        if (cartState) syncControls(cartState);
        variantIds.forEach(function(variantId) {
          setLoading(Number(variantId), false);
        });
        if (window.themeShowToast) window.themeShowToast('Unable to update cart');
      });
  }

  function scheduleVariantUpdate(variantId) {
    window.clearTimeout(updateTimers[variantId]);
    updateTimers[variantId] = window.setTimeout(function() {
      updateTimers[variantId] = null;
      commitPendingQuantities();
    }, updateDelay);
  }

  function setVariantQuantity(control, quantity) {
    var variantId = getVariantId(control);
    var nextQuantity = Math.max(0, quantity);

    pendingQuantities[variantId] = nextQuantity;
    setDisplayedQuantity(variantId, nextQuantity);
    scheduleVariantUpdate(variantId);
  }

  function scheduleInputUpdate(control) {
    var input = getInput(control);
    if (!input || input.value === '') return;

    var variantId = getVariantId(control);
    window.clearTimeout(inputTimers[variantId]);
    inputTimers[variantId] = window.setTimeout(function() {
      setVariantQuantity(control, getQuantity(input));
    }, 250);
  }

  function init() {
    if (!getControls().length) return;
    fetchCart(true).then(syncControls).catch(function() {});
  }

  document.addEventListener('click', function(event) {
    var increase = event.target.closest('[data-grid-qty-increase]');
    var decrease = event.target.closest('[data-grid-qty-decrease]');
    var button = increase || decrease;
    if (!button || button.disabled) return;

    var control = button.closest('[data-grid-quantity-control]');
    var input = control ? getInput(control) : null;
    if (!input) return;

    setVariantQuantity(control, getQuantity(input) + (increase ? 1 : -1));
  }, true);

  document.addEventListener('input', function(event) {
    if (!event.target.matches('[data-grid-qty-input]')) return;
    var control = event.target.closest('[data-grid-quantity-control]');
    if (control) scheduleInputUpdate(control);
  });

  document.addEventListener('change', function(event) {
    if (!event.target.matches('[data-grid-qty-input]')) return;
    var control = event.target.closest('[data-grid-quantity-control]');
    if (control) setVariantQuantity(control, getQuantity(event.target));
  });

  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
